import styles from "./Invitations.module.css";
import { Sidebar, Navbar, ListsTable } from "../../components/index";

function Invitations() {
  return (
    <div className={styles["main-container"]}>
      <Sidebar />
      <main className=" p-6 flex flex-col gap-8">
        <h1 className="text-4xl font-bold">Invitations</h1>
        <ListsTable lists={[]} />
      </main>
      <Navbar />
    </div>
  );
}

export default Invitations;
